export default {
  border: true,
  rounded: '@theme:card.rounded',
  fontSize: '3',
  fontWeight: 'bold',
  cursor: 'pointer',
  fareBodyItem: {
    borderRight: true,
    alignItems: 'center',
    height: '100',
    paddingWidth: '2',
    paddingBottom: '0',
    marginBottom: '4',
  },
  showBackgroundImage: false,
  fareItemBackgroundImage: {
    rounded: '@theme:card.rounded',
  },
  showDate: true,
  fareItemDate: {
    textTransform: 'uppercase',
    fontSize: '4',
    paddingBottom: '3',
    monthFormat: 'fullMonths',
    yearStyles: {
      fontWeight: 'light',
    },
  },
  showDurationTrip: false,
  showDepartureInfo: false,
  showReturnInfoFalse: false,
  showLastSeen: false,
  showOriginDestination: false,
  showHorizontalSeparator: false,
  showDepartureReturnBeforePrice: true,
  fareItemPrice: {
    pricePromoLabelKey: 'cmp-fare-price-promo-short',
    showCurrencyCode: true,
    showCurrencySymbol: false,
    showPricePromo: true,
    textAlign: 'center',
    paddingBottom: '2',
    style: { lineHeight: '1' },
    pricePromoStyles: {
      fontWeight: 'light',
      textTransform: 'uppercase',
      fontSize: '10px',
    },
    currencyStyles: {
      fontSize: '5',
      marginHeight: '2px',
    },
  },
  fareItemJourneyTypeTravelClass: {
    display: 'flex',
  },
  fareItemNoPriceAvailable: {
    showIcon: false,
    alignItems: 'center',
    marginTop: 'auto',
    messageStyles: {
      paddingBottom: '26px',
      marginTop: '-20px',
      fontWeight: 'light',
      width: '75',
    },
    showLinkAvailability: true,
    linkAvailabilityStyles: {
      padding: '0',
      fontWeight: 'bold',
      fontSize: '3',
      textColor: 'black',
      textTransform: 'uppercase',
      style: { textDecoration: 'underline' },
    },
  },
};
